// ** Angular Core & Common Imports
import { NgOptimizedImage } from '@angular/common';
import { Component, Input } from '@angular/core';

// ** Pipe Imports
import { CdnUrlPipe } from '@shared/pipes/cdn-url.pipe';


@Component({
  selector: 'app-logo',
  standalone: true,
  imports: [
    NgOptimizedImage,
    CdnUrlPipe
  ],
  template: `<img
    [ngSrc]="logoFile | cdnUrl:'images/logos'"
    alt="Hala Logo"
    [width]="width"
    [height]="height"
    priority
  />`,
  styles: ``,
})

export class LogoComponent {
  @Input() width: number = 85.333;
  @Input() height: number = 28;
  @Input() isHomepage!: boolean;
  @Input() isScrolled!: boolean;
  @Input() isMenuHovered!: boolean;

  get logoFile(): string {
    if (this.isHomepage && !this.isScrolled && !this.isMenuHovered) {
      return 'logo-white.svg';
    }
    return 'logo.svg';
  }
}